import { render, staticRenderFns } from "./lifeguard.vue?vue&type=template&id=2f4ed34a&scoped=true&"
import script from "./lifeguard.vue?vue&type=script&lang=js&"
export * from "./lifeguard.vue?vue&type=script&lang=js&"
import style0 from "./lifeguard.vue?vue&type=style&index=0&id=2f4ed34a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ed34a",
  null
  
)

export default component.exports